<template>
	<div>
		<router-view v-if="$route.path.includes('MyReviewDatails')"></router-view>
		<div v-else>
			<div class="dingdan">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  <el-breadcrumb-item>个人中心</el-breadcrumb-item>
				  <el-breadcrumb-item>我的评审</el-breadcrumb-item>
				</el-breadcrumb>
				<div class="fh_button">
					<i class="el-icon-arrow-left"></i>
					<p>返回</p>
				</div>
			</div>
			<div class="MyWallet">
				<div class="MyWalletbox">
					<div class="MyWalletbox1">
						<img src="@/assets/bei1.png" alt="" srcset="" />
						<div class="MyWalletbox1_1">
							<img src="@/assets/shou1.png" alt="" srcset="" />
							<div class="MyWalletbox1_zong">
								<p>评审金总收益(元)</p>
								<span>{{userinfo.total_review_money || "0.00"}}</span>
							</div>
						</div>
					</div>
					<div class="MyWalletbox1">
						<img src="@/assets/bei2.png" alt="" srcset="" />
						<div class="MyWalletbox1_1">
							<img src="@/assets/shou2.png" alt="" srcset="" />
							<div class="MyWalletbox1_zong">
								<p>冻结中评审金(元)</p>
								<span>{{userinfo.frozen_review_money || "0.00"}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="walletTitle">
					<img src="@/assets/jg.png" alt="" srcset="" />
					<span>败方评审金将原路退回。PC端不支持提现，如需提现请到小程序端操作</span>
				</div>
				
				<div class="quanbulist">
					<ul>
						<li v-for="(i,Index) in navlist"   @click="tobnav(Index)" :class="{'quanbu':Index==Navindex}">{{i.name}}</li>
					</ul>
				</div>
				
				<div class="zijin">
					<div class="zijin1">
			            <div class="zijinTitle" v-for="(i) in list" @click="datails(i.oru_id)">
							<div class="zijinTitle1">{{i.order.demand.name}}</div>
							<div v-if="i.status==0" class="review_start" style="background:#FFE6E6;color:#FF0000;">待评审</div>
							<div v-if="i.status==-1" class="review_start" style="background:#EBEBEB;color:#999999;">过期未评审</div>
							<div v-if="i.status==1" class="review_start" style="background:#DBF4CC;color:#4DC800;">已评审</div>
							
							<div class="zijinTitle2">
								<img src="@/assets/pay1.png" alt="" srcset="" />
								<p>评审金额：<span>￥{{i.price}}</span></p>
							</div>
							<div class="zijinTitle3" v-if="i.status==0">
								<div class="zijinTitle3_1">剩余时间：<CountDown :endTime="i.expire_time*1000"></CountDown></div>
								<div class="reviewList_footer3" v-if="i.is_assign==1" style="font-size:28rpx;color:#FF0000;">
									平台分配
								</div>
								<div class="zijinTitle3_2" @click.stop="qingshen()">立即评审</div>
							</div>
						</div>
					</div>
				</div>
				<div class="fenye" v-if="total>6">
				   <el-pagination
					 background
					 @size-change="handleSizeChange"
					 @current-change="handleCurrentChange"
					 :current-page.sync="currentPage1"
					 :page-size="6"
					 layout="total, prev, pager, next ,jumper"
					 :total="total">
				   </el-pagination>
				</div>
			</div>
		</div>
		
		<el-dialog
		  title="发布需求"
		  :visible.sync="centerDialogVisible"
		  width="810px">
		  <div class="FBxq">
			<h4>选择支持方<span>*</span></h4>
			<p>请根据实际情况选择您支持的一方</p>
			<div class="fuwulist">
				<div class="fuwulist1" :class="{'xuanzhong':radio==1}">
					<el-radio v-model="radio" label="1" fill="#1E3A8A">
						<div class="fuwulist1_1">
							<img src="@/assets/fabu.png" alt="" srcset="" />
							<span>需求方</span>
						</div>
					</el-radio>
				</div>
				<div class="fuwulist1" :class="{'xuanzhong':radio==2}">
					<el-radio v-model="radio" label="2" fill="#1E3A8A">
						<div class="fuwulist1_1">
							<img src="@/assets/xuqiu.png" alt="" srcset="" />
							<span>服务方</span>
						</div>
					</el-radio>
				</div>
			</div>
			<h4 style="margin-top:24px;">评审意见<span>*</span></h4>
			<p>请详细说明您的评审理由和依据</p>
			<div class="FBxqText">
				<textarea name="" id="" cols="30" rows="10" placeholder="请输入内容"></textarea>
			</div>
			<div class="FBxqFooter">
				<div class="FBxqFooter1"  @click="quxiao">取消</div>
				<div class="FBxqFooter2">提交评审</div>
			</div>
		  </div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		OrderReviewUser,
		personal
	} from "@/api/api.js"
	import CountDown from '@/common/CountDown.vue'
	// import rightsidebarImg from '@/common/rightsidebarImg.vue';
	export default {
	  name: 'HelloWorld',
	  components:{
		CountDown
	  },
	  data() {
	    return {
			centerDialogVisible:false,
			radio:'1',
			navlist:[
				{name:"全部",status:""},
				{name:"待评审",status:"0"},
				{name:"过期未评审",status:"-1"},
				{name:"已评审",status:"1"},
			],
			Navindex:0,
			status:"",
			page:1,
			list:[],
			userinfo:"",
			total:"",
			pagecount:"",
			currentPage1:""
	    }
	  },
	  created() {
	  	this.getlist()
	  	this.getuserinfo()
	  },
	  methods: {
		handleCurrentChange(e){
			this.page=e
			this.getlist()
		},
		getuserinfo(){
			personal({}).then(res=>{
				this.userinfo=res.data
			})
		},
		tobnav(index){
			this.Navindex=index
			this.status=this.navlist[index].status
			this.getlist()
		},
		quxiao(){
			this.centerDialogVisible = false
		},
		qingshen(){
			this.centerDialogVisible = true
		},
		qiehuan(index){
			this.typeindex=index
		},
		getlist(){
			OrderReviewUser({
				status:this.status,
				page:this.page,
				limit:"6"
			}).then(res=>{
				this.list=res.data.data.data
				this.total= res.data.data.total
				this.pagecount=res.data.data.pass_count
				this.currentPage1=res.data.data.current_page
			})
		},
		datails(e){
			const targetPath = '/serviceHome/MyReview/MyReviewDatails?oru_id='+e
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		}
	  },
	}
</script>
<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.MyWallet{
		width:1200px;
		margin: 0 auto;
	}
	.MyWalletbox{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.MyWalletbox1,.MyWalletbox2{
		width: 588px;
		height: 120px;
		position: relative;
	}
	.MyWalletbox1_1{
		width:100%;
		height:100%;
		position:absolute;
		top: 0;
		left: 0;
		padding:20px;
		box-sizing: border-box;
	}
	.MyWalletbox1_1 {
		display:flex;
		align-items: center;
	}
	.MyWalletbox1_1>img{
		width:60px;
		height:60px;
		margin-right:20px;
	}
	
	.MyWalletbox1_zong{
		width:100%;
	}
	.MyWalletbox1_zong p{
		font-weight: 400;
		font-size: 20px;
		color: #FFFFFF;
	}
	.MyWalletbox1_zong span{
		font-weight: bold;
		font-size: 24px;
		color: #FFFFFF;
	}
	.MyWalletbox1>img{
		width:100%;
		height:100%;
	}
	.MyWalletbox2{
		width: 588px;
		height: 196px;
		background: linear-gradient( 180deg, rgba(66,151,255,0.2) 0%, rgba(66,151,255,0) 20%, rgba(255,255,255,1) 100%);
		border-radius:12px;
		padding:20px;
		box-sizing: border-box;
	}
	.MyWalletbox2_title{
		width:100%;
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	
	.walletTitle{
		width:100%;
		height:33px;
		padding: 0px 10px;
		line-height:33px;
		background-color:#DBDEE7;
		box-sizing: border-box;
		border-radius:8px;
		margin-top:12px;
		font-weight: 400;
		font-size: 14px;
		color: #1E3A8A;
		display:flex;
		align-items: center;
	}
	.walletTitle img{
		width:16px;
		height:16px;
		margin-right:8px;
	}
	.zijin{
		width:100%;
		border-radius:12px;
		margin-top:20px;
	}
	.quanbulist{
		width:100%;
		margin-top:10px;
	}
	.quanbulist ul{
		width:100%;
		display:flex;
		align-items: center;
	}
	
	.quanbulist li{
		font-weight: 400;
		font-size: 14px;
		color: rgba(0,0,0,0.6);
		margin-right:32px;
		cursor: pointer;
	}
	.quanbu{
		color: #0052D9 !important;
		border-bottom:1px solid #0052D9;
		padding:10px;
		box-sizing: border-box;
	}
	
	.fenye{
		width:100%;
		display:flex;
		justify-content:center;
		align-items: center;
		padding-bottom:60px;
		margin-top:20px;
	}
	.zijin1{
		width:100%;
		display:flex;
		flex-wrap:wrap;
	}
	.zijinTitle{
		width: 384px;
		height: 122px;
		background: #FFFFFF;
		border-radius: 12px;
		padding:12px;
		box-sizing: border-box;
		margin-right:24px;
		margin-bottom:24px;
		position:relative;
		overflow: hidden;
	}
	.review_start{
		position:absolute;
		top: 0px;
		right:0px;
		width:100px;
		text-align: center;
		border-radius:0px 0px 0px 12px;
		font-size:14px;
		line-height:30px;
	}
	.zijin1>div:nth-child(3n){
		margin-right:0 !important;
	}
	.zijinTitle1{
		width:100%;
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.zijinTitle2{
		display:flex;
		align-items: center;
		margin-top:12px;
		margin-bottom:12px;
	}
	.zijinTitle2 img{
		width:15px;
		height:15px;
		margin-right:5px;
	}
	.zijinTitle2 p{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
	}
	.zijinTitle2 span{
		font-weight: 500;
		font-size: 14px;
		color: #FF5900;
	}
	.zijinTitle3{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.zijinTitle3_1{
		padding:3px 5px;
		box-sizing: border-box;
		background: rgba(255,0,0,0.1);
		border-radius: 4px;
		font-weight: 500;
		font-size: 12px;
		color: #FF0000;
	}
	.zijinTitle3_2{
		width: 76px;
		height: 32px;
		line-height:32px;
		background: #1E3A8A;
		border-radius: 8px;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		justify-content:center;
		cursor: pointer;
	}
	::v-deep .el-dialog {
		border-radius:8px;
	}
	::v-deep .el-dialog__body {
	    padding: 0px 20px 20px;
	}
	.fuwulist{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-top:20px;
	}
	.fuwulist1{
		width: 373px;
		height: 90px;
		background: #EFF0F1;
		border-radius: 12px;
		padding:20px;
		box-sizing: border-box;
	}
	.fuwulist1 img{
		width:42px;
		height:42px;
		margin-right:10px;
	}
	.fuwulist1_1{
		display:flex;
		align-items:center;
	}
	::v-deep .el-radio {
		display:flex;
		align-items:center;
	}
	.xuanzhong{
		background-color:#DDE2EE !important;
	}
	::v-deep .el-radio__input.is-checked+.el-radio__label {
	    color: #333;
	}
	.FBxq>h4{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.FBxq>h4>span{
		font-weight: bold;
		font-size: 14px;
		color: #FF0000;
	}
	.FBxq>p{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
	}
	.FBxqText{
		width:100%;
		margin-top:20px;
	}
	.FBxqText textarea{
		width:100%;
		height: 177px;
		resize: none;
		outline:none;
		background: #FFFFFF;
		border-radius: 8px 8px 8px 8px;
		border: 1px solid rgba(30,58,138,0.2);
		padding:10px;
		box-sizing: border-box;
	}
	.FBxqFooter{
		width:100%;
		padding:10px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:center;
		align-items:center;
	}
	.FBxqFooter1{
		width: 112px;
		height: 40px;
		background: rgba(30,58,138,0.15);
		border-radius: 8px ;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 500;
		font-size: 16px;
		color: #1E3A8A;
		cursor:pointer;
	}
	.FBxqFooter2{
		width: 112px;
		height: 40px;
		background: #1E3A8A;
		border-radius: 8px ;
		margin-left:32px;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		cursor:pointer;
	}
</style>